<template>
    <v-container v-if="isLoaded">
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-toolbar flat color="white">
                        <v-btn color="primary" text @click="$router.push({ name: 'menu' })">
                            <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                        <v-toolbar-title>Categories</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="openEditCategoryDialog()"> <v-icon>add</v-icon>Create </v-btn>
                        <v-btn icon @click="viewMode = !viewMode"><v-icon>apps</v-icon></v-btn>
                    </v-toolbar>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="categories.length > 0">
            <v-col v-if="viewMode" cols="12">
                <v-data-table :headers="headers" :items="categories" :items-per-page="100" class="elevation-1">
                    <template v-slot:item="props">
                        <tr
                            @click="
                                $router.push({
                                    name: 'businesses.menu-category-products',
                                    params: { categoryId: props.item.id },
                                })
                            "
                        >
                            <td class="text-xs-left">{{ props.item.order }}</td>
                            <td class="text-xs-left">
                                {{ props.item | displayLang('title', $store.state.lang) }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item | displayLang('description', $store.state.lang) }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.number_of_products }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.visibility }}
                            </td>
                            <td class="text-xs-left">
                                <v-icon small class="mr-2" @click.stop="openEditCategoryDialog(props.item)">edit</v-icon>
                                <v-icon small @click.stop="openDeleteCategoryDialog(props.item)">delete</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
            <v-col v-else cols="12" xs="12" sm="6" md="6" lg="4" xl="3" v-for="category in categories" :key="category.id">
                <v-card class="mx-2">
                    <v-toolbar flat color="white">
                        <v-toolbar-title>{{ category | displayLang('title', $store.state.lang) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="
                                $router.push({
                                    name: 'businesses.menu-category',
                                    params: { categoryId: category.id },
                                })
                            "
                        >
                            <v-icon>visibility</v-icon>
                        </v-btn>
                        <v-btn icon @click="openEditCategoryDialog(category)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn icon @click="openDeleteCategoryDialog(category)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-chip label class="ma-2 ml-2" outlined color="#555"> {{ category.number_of_products }} products </v-chip>
                    <v-chip v-if="category.visibility" class="ma-2 ml-0" color="green">Visible</v-chip>
                    <v-chip v-else class="ma-2 ml-0" color="grey">Not visible</v-chip>
                </v-card>
            </v-col>
        </v-row>
        <v-parallax v-else dark style="background-color: #C3C3C3;">
            <v-row align="center" justify="center">
                <v-col>
                    <h1 class="display-2 font-weight-thin mb-3">
                        Business menu categories
                    </h1>
                    <h4 class="subheading">
                        Business menu has not categories...
                    </h4>
                    <v-btn color="primary" @click="openEditCategoryDialog()">Create category</v-btn>
                </v-col>
            </v-row>
        </v-parallax>
        <v-dialog v-model="editCategoryDialog" width="500" persistent>
            <v-card>
                <v-toolbar flat color="white">
                    <v-toolbar-title v-if="category.id">Edit category</v-toolbar-title>
                    <v-toolbar-title v-else>New category</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <v-btn v-for="langObject in langs" :key="langObject.value" small icon @click="pickLang(langObject)" :class="{ selected: lang === langObject.value }"
                            ><flag :iso="langObject.icon"
                        /></v-btn>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form v-on:submit.prevent ref="categoryForm" v-model="valid" lazy-validation @keydown.native="dialogKeyEventHandler">
                        <v-row dense>
                            <v-col cols="12" v-if="lang === 'english'">
                                <v-text-field
                                    v-model="category.title_en"
                                    ref="title_en"
                                    :label="titleLabel"
                                    prepend-icon="label"
                                    :rules="[rules.required]"
                                    dense
                                    @change="updateTitle()"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'english'">
                                <v-textarea
                                    v-model="category.description_en"
                                    :label="descriptionLabel"
                                    prepend-icon="description"
                                    dense
                                    rows="2"
                                    @change="updateDescription()"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'greek'">
                                <v-text-field v-model="category.title_gr" ref="title_gr" :label="titleLabel" prepend-icon="label" dense></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'greek'">
                                <v-textarea v-model="category.description_gr" :label="descriptionLabel" prepend-icon="description" dense rows="2"></v-textarea>
                            </v-col>
                            <v-col v-if="category.id" cols="6">
                                <v-text-field v-model="category.order" type="number" label="Order" prepend-icon="cake" dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-switch class="ml-0 px-0 mt-1" v-model="category.visibility" label="Visible"></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray" text @click="editCategoryDialog = false">Cancel</v-btn>
                    <v-btn color="error" text @click="validate()">
                        <span v-if="category.id">Update</span>
                        <span v-else>Create</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteCategoryDialog" width="400">
            <v-card>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Delete category {{ category.title_en }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    Are you sure you wantr to delete category
                    {{ category.title_en }}?
                    <span v-if="category.number_of_products && category.number_of_products.length > 0"
                        >There are {{ category.number_of_products }} products in this category which will be lost if you delete this category!!</span
                    >
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray" text @click="deleteCategoryDialog = false">Cancel</v-btn>
                    <v-btn color="error" text @click="deleteCategory()">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as R from 'ramda';
import { BusinessesApi, MenuApi } from '@/api';
import { dates, fonts, filters } from '@/utils/mixins';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';

export default {
    name: 'Menu',
    mixins: [dates, fonts, filters],
    data() {
        return {
            isLoaded: false,
            titleLabel: 'Title - EN',
            descriptionLabel: 'Description - EN',
            viewMode: true,
            valid: true,
            menu: null,
            categories: [],
            category: {},
            editCategoryDialog: false,
            deleteCategoryDialog: false,
            lang: 'english',
            langs: [
                {
                    text: 'English',
                    value: 'english',
                    icon: 'gb',
                },
                {
                    text: 'Greek',
                    value: 'greek',
                    icon: 'gr',
                },
            ],
            headers: [
                {
                    text: 'Order',
                    value: 'order',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    text: 'Title',
                    value: 'title_en',
                    align: 'left',
                    width: '20%',
                    sortable: true,
                },
                {
                    text: 'Description',
                    value: 'description_en',
                    align: 'left',
                    width: '30%',
                    sortable: false,
                },
                {
                    text: 'Products',
                    value: 'number_of_products',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    text: 'Visible',
                    value: 'visibility',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    align: '',
                    sortable: false,
                    text: 'Actions',
                    value: 'action',
                    width: '5%',
                },
            ],
            rules: {
                required: value => !!value || 'Field is required',
            },
        };
    },
    async created() {
        const { data: business } = await BusinessesApi.get(this.$route.params.id);
        if (business.menus) {
            await this.loadMenu(business.menus);
        }
        if (this.menu) {
            await this.loadCategories();
        }
        this.isLoaded = true;
    },
    methods: {
        dialogKeyEventHandler(event) {
            if (event.key === 'Escape') {
                this.editCategoryDialog = false;
            }

            if (event.ctrlKey && event.key === '1') {
                event.preventDefault();
                this.pickLang(this.langs[0]);
            }
            if (event.ctrlKey && event.key === '2') {
                event.preventDefault();
                this.pickLang(this.langs[1]);
            }
            if (event.shiftKey && event.key === 'Enter') {
                this.validate();
                this.openEditCategoryDialog();
            } else if (event.key === 'Enter') {
                this.validate();
            }
        },
        updateTitle() {
            if (this.category.title_gr === null || this.category.title_gr === undefined) {
                this.category.title_gr = this.category.title_en;
            }
        },
        updateDescription() {
            if (this.category.description_gr === null || this.category.description_gr === undefined) {
                this.category.description_gr = this.category.description_en;
            }
        },
        pickLang(selectedLang) {
            this.lang = selectedLang.value;
            this.$nextTick(() => {
                if (this.lang === 'english') {
                    this.$refs.title_en.focus();
                    this.titleLabel = 'Title - EN';
                    this.descriptionLabel = 'Description - EN';
                }
                if (this.lang === 'greek') {
                    this.$refs.title_gr.focus();
                    this.titleLabel = 'Title - GR';
                    this.descriptionLabel = 'Description - GR';
                }
            });
        },
        validate() {
            if (this.$refs.categoryForm.validate()) {
                this.updateCategory();
            }
        },
        reset() {
            if (this.$refs.categoryForm) {
                this.$refs.categoryForm.reset();
                this.lang = 'english';
                this.pickLang(this.langs[0]);
            }
        },
        async loadMenu() {
            try {
                const { data: menu } = await MenuApi.get(this.$route.params.menuId);
                this.menu = menu;
            } catch (e) {
                this.menu = null;
            }
        },
        async loadCategories() {
            try {
                const { data: categories } = await MenuApi.getCategories({
                    menu: this.menu.id,
                });
                this.categories = categories;
            } catch (e) {
                this.menu = null;
            }
        },
        async createMenu() {
            const { data: menu } = await MenuApi.create({
                business: this.$route.params.id,
            });
            this.menu = menu;
            await this.loadCategories();
        },
        openEditCategoryDialog(category) {
            this.lang = 'english';
            if (category === undefined) {
                this.category = {};
                this.reset();
                this.category.visibility = true;
            } else {
                this.category = R.clone(category);
            }
            this.editCategoryDialog = true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.title_en.focus();
                });
            });
        },
        async updateCategory() {
            this.category.menu = this.menu.id;
            this.editCategoryDialog = false;
            if (this.category.id) {
                await MenuApi.updateCategory(this.category);
            } else {
                await MenuApi.createCategory(this.category);
            }
            this.loadCategories();
            this.$store.commit(SET_SNACKBAR_STATUS, {
                message: 'Category created!',
                color: 'success',
            });
            this.category = {};
        },
        openDeleteCategoryDialog(category) {
            this.category = category;
            this.deleteCategoryDialog = true;
        },
        async deleteCategory() {
            await MenuApi.deleteCategory(this.category.id);
            this.loadCategories();
            this.$store.commit(SET_SNACKBAR_STATUS, {
                message: `Category ${this.category.title_en}`,
                color: 'success',
            });
            this.deleteCategoryDialog = false;
            this.category = {};
        },
    },
};
</script>

<style scoped>
.selected {
    background-color: rgba(100, 200, 300, 0.8);
}
</style>
